import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private dialog: MatDialog) {}

  async open(component: any, data?: any): Promise<MatDialogRef<any>> {
    const dialogRef = this.dialog.open(component, {
      data,
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      width: '100vw',
      panelClass: 'fullscreen-dialog',
      backdropClass: 'dark-backdrop'
    });
    return dialogRef;
  }

  async close(dialogRef: MatDialogRef<any>): Promise<void> {
    dialogRef.close();
  }
}